import React from "react";
// import { Download } from "lucide-react";
// import { Button } from "../../Components/ui/button.jsx";
import { useOverview } from "./../../hooks.js";
import Lottie from "react-lottie";
import { lottieOptions, reFormatDate } from "./../../Utils/helperFunction.js";
import { Success } from "./../../Public/assets/index.js";

const WalletConfirmation = ({ walletTransferDetails }) => {
  const { selectedCurrency, selectedToCurrency, charges } = useOverview();

  const getFeeDisplay = () => {
    if (!charges?.totalFees || charges.totalFees === "-") {
      return "-";
    }

    // Check if totalFees is "0" or "0.0" or "0.00"
    const isZero = parseFloat(charges.totalFees) === 0;

    if (isZero) {
      return "Free";
    }

    return `${charges.totalFees} ${selectedCurrency?.vendorCurrency}`;
  };
  return (
    <div className="flex  py-6 ">
      <div className="w-full max-w-md">
        <div className="  space-y-4">
          <div className="flex justify-center">
            <div className="rounded-full">
              <Lottie
                options={lottieOptions(Success)}
                width={150}
                height={150}
              />
            </div>
          </div>
          <div className="text-center space-y-1">
            <h3 className="text-xl text-blackShade leading-[28px] font-normal">
              Your conversion has been initiated
            </h3>
            <p className="text-sm font-normal text-greyish">
              Transfer ID : {walletTransferDetails.transactionNo}
            </p>
          </div>
          {/* <div className="flex justify-center">
            <Button className="  w-[85%]" variant="outline">
              <Download className="mr-2 h-4 w-4" /> Download Payment
              Confirmation
            </Button>
          </div> */}
          <div className="space-y-4 bg-greyish px-4 py-2.5 rounded">
            <div className="flex flex-col space-y-1 justify-between border-b py-2.5">
              <span className="text-xs font-normal text-greyish">
                You will receive
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {walletTransferDetails.amount}{" "}
                {walletTransferDetails.toCurrency}
              </span>
            </div>
            {/* <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                Remaining Balance
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {selectedCurrency?.balance} {selectedCurrency?.vendorCurrency}
              </span>
            </div> */}
            <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                Currency Conversion
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {walletTransferDetails.fromCurrency} to{" "}
                {walletTransferDetails.toCurrency}
              </span>
            </div>
            {/* <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                To Currency
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {walletTransferDetails.toCurrency}
              </span>
            </div> */}
            <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                Exchange Rate
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                1 {selectedCurrency?.vendorCurrency} = {charges?.rate}{" "}
                {selectedToCurrency?.vendorCurrency}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">Date</span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {reFormatDate(walletTransferDetails.createdAt)}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-xs font-normal text-greyish">
                Transfer Fee
              </span>
              <span className="font-geomanistBold text-sm text-blackShade">
                {/* {walletTransferDetails?.fees}{" "}
                {walletTransferDetails?.fromCurrency} */}
                {getFeeDisplay()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletConfirmation;
